import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { ConfigService } from '../core/shared/config.service';
import { ToastService } from '../core/shared/toast.service';
import { UtilsService } from '../core/shared/utils.service';
import { environment } from '../../environments/environment';

@Component({
	selector: 'app-completed',
	templateUrl: './completed.component.html',
	styleUrls: ['./completed.component.scss']
})
export class CompletedComponent implements OnInit, OnDestroy {

	private readonly DOWNLOAD_FILENAME: string = 'numero-seguimiento.txt';
	private readonly SUBSCRIPTIONS: Subscription = new Subscription();

	private formID: any = '';

	public readonly TRACKING_WARNING: string = 'Aviso: guarde bien este número de seguimiento. Si no ha facilitado un correo electrónico, esta será su única forma de acceder a la denuncia.';

	public loading: boolean = true;
	public messages: any = {};
	public logo: string = '';
	public trackingCode: string = '';
	public copied: boolean = false;

	constructor(private route: ActivatedRoute,
		private configService: ConfigService,
		private spinner: NgxSpinnerService,
		private toastService: ToastService,
		private utilsService: UtilsService,
		private router: Router) { }

	ngOnInit(): void {
		this.trackingCode = history.state?.trackingCode ?? '';

		this.SUBSCRIPTIONS.add(this.route.paramMap.subscribe(async (params: ParamMap) => {
			this.loading = true;

			this.spinner.show();

			this.formID = params.get('formID');

			try {
				if (!!this.formID && this.formID !== '') {
					const config: any = await this.configService.getMessages(this.formID, 'completed');

					if (config.data != null) {
						this.messages = config.data;
						this.logo = `${environment.imagesUrl}${this.messages.FormLogo}`
					} else {
						await this.router.navigateByUrl(`not-found`);
					}
				} else {
					await this.router.navigateByUrl(`not-found`);
				}
			} catch (error: any) {
				this.toastService.danger('there was an error loading data');
				console.error('Error loading data: ', error);
			} finally {
				this.spinner.hide();
				this.loading = false;
			}
		}));
	}

	ngOnDestroy(): void {
		this.SUBSCRIPTIONS.unsubscribe();
	}

	/**
     * Copies the tracking code to the system clipboard and 
     * manages a temporary confirmation state.
     * @returns A promise that resolves when the text has been successfully copied.
     */
	public async copyTrackingCode(): Promise<void> {
		await navigator.clipboard.writeText(this.trackingCode);
		this.copied = true;
		setTimeout(() => this.copied = false, 2000);
	}

	/**
	 * Builds the tracking-code text content and delegates its download
	 * as a plain-text file to the utils service.
	 * @returns {void}
	 */
	public downloadTrackingCode(): void {
		if (!this.trackingCode)
			return;

		const content: string = `${this.trackingCode}\n\n${this.TRACKING_WARNING}`;

		this.utilsService.downloadTextFile(content, this.DOWNLOAD_FILENAME);
	}

}
